__turbopack_context__.v({
  "playbutton": "ao8Tda_playbutton",
  "playbuttoninner": "ao8Tda_playbuttoninner",
  "videoProgressBar": "ao8Tda_videoProgressBar",
  "videoWrapper": "ao8Tda_videoWrapper",
  "wrapper": "ao8Tda_wrapper",
});
